import type { BenefitSummary } from "@yutai/shared"
import { BenefitCard } from "./BenefitCard.js"
import styles from "./BenefitCardsSection.module.css"

interface Props {
  sectionId: string
  title: string
  lead?: string
  benefits: BenefitSummary[]
  cardBorderVariant?: "default" | "gradient"
  className?: string
}

export function BenefitCardsSection({
  sectionId,
  title,
  lead,
  benefits,
  cardBorderVariant = "default",
  className,
}: Props) {
  if (benefits.length === 0) return null

  return (
    <section
      className={[styles.section, className].filter(Boolean).join(" ")}
      aria-labelledby={sectionId}
    >
      <h2 id={sectionId} className={styles.sectionTitle}>
        {title}
      </h2>
      {lead && <p className={styles.lead}>{lead}</p>}
      <div className={styles.list}>
        {benefits.map((benefit) => (
          <BenefitCard key={benefit.id} benefit={benefit} borderVariant={cardBorderVariant} />
        ))}
      </div>
    </section>
  )
}
